import type { FC, ReactNode, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const base = (props: IconProps) => ({
    viewBox: '0 0 24 24',
    'aria-hidden': true,
    focusable: false,
    ...props
})

export const YouTubeIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <rect x='2' y='5' width='20' height='14' rx='4.5' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <path d='M10 9.2v5.6l4.8-2.8L10 9.2Z' fill='currentColor' />
    </svg>
)

export const SpotifyIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <circle cx='12' cy='12' r='9.4' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <path d='M7.2 9.4c3.4-1 7.1-.7 10 .9M7.8 12.4c2.8-.8 5.8-.5 8.2.8M8.4 15.2c2.2-.6 4.4-.4 6.3.6' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
)

export const InstagramIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <rect x='3' y='3' width='18' height='18' rx='5.2' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <circle cx='12' cy='12' r='4.1' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <circle cx='17.3' cy='6.7' r='1.1' fill='currentColor' />
    </svg>
)

export const AppleMusicIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <rect x='3' y='3' width='18' height='18' rx='5.2' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <path d='M14.6 7.2v7.3a1.9 1.9 0 1 1-1.3-1.8V9l-3.6.9v5.9a1.9 1.9 0 1 1-1.3-1.8V8.7l6.2-1.5Z' fill='currentColor' />
    </svg>
)

export const SoundCloudIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <path d='M10 16.5V9.2a5 5 0 0 1 9.4 2.4 2.6 2.6 0 0 1-.4 5.2H10Z' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinejoin='round' />
        <path d='M7.5 16.5v-5.5M5 16.5v-4M2.5 16.5v-2.2' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
    </svg>
)

export const FacebookIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <circle cx='12' cy='12' r='9.4' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <path d='M13.2 20.5v-6.6h2.3l.4-2.7h-2.7V9.6c0-.8.3-1.3 1.4-1.3H16V5.9c-.3 0-1.1-.1-2-.1-2 0-3.4 1.2-3.4 3.5v1.9H8.4v2.7h2.2v6.6' fill='none' stroke='currentColor' strokeWidth='1.4' strokeLinejoin='round' />
    </svg>
)

export const XIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <path d='M4.5 4.5h4.2l10.8 15H15.3L4.5 4.5ZM19.2 4.5l-5.9 6.6M10.6 13.7l-5.8 5.8' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
)

export const JioSaavnIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <circle cx='12' cy='12' r='9.4' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <path d='M10.2 15.8V8.4l5.6-1.2v7.2' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinejoin='round' />
        <circle cx='8.9' cy='15.8' r='1.4' fill='currentColor' />
        <circle cx='14.5' cy='14.4' r='1.4' fill='currentColor' />
    </svg>
)

export const AmazonMusicIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <path d='M4.5 14.8c4.6 3 10.3 3 15 0' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
        <path d='M17.2 13.6l2.4 1.2-.6 2.6' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M9.4 11.4V5.6l5.2-1v5.6' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinejoin='round' />
        <circle cx='8.2' cy='11.4' r='1.3' fill='currentColor' />
        <circle cx='13.4' cy='10.2' r='1.3' fill='currentColor' />
    </svg>
)

export const YouTubeMusicIcon: FC<IconProps> = (props): ReactNode => (
    <svg {...base(props)}>
        <circle cx='12' cy='12' r='9.4' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <circle cx='12' cy='12' r='5' fill='none' stroke='currentColor' strokeWidth='1.4' />
        <path d='M10.6 9.8v4.4l3.7-2.2-3.7-2.2Z' fill='currentColor' />
    </svg>
)
